import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Page from 'src/components/Page';
import { Box, Grid, Container, Typography, Alert } from '@mui/material';
// import styles from "./styles.module.css";
import QuillEditor from 'react-quill';
// import StyleSheet from 'styled-components/dist/sheet/Sheet';
import { styled } from '@mui/material/styles';
import { api } from 'src/Api';
import { LoadingButton } from '@mui/lab';

export default function TermsCondition() {
  // const input = document.createElement('input');
  // input.setAttribute('type', 'file');
  // input.setAttribute('accept', 'image/*');
  // input.click();
  const [alert, setalert] = useState({ visible: false, message: '' });

  const [value, setValue] = useState('');
  const quill = useRef();
  const [loading, setloading] = useState(false);
  const [gettoken, setGettoken] = useState('');
  const [editid, seteditId] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('token');
    setGettoken(token);
    if (gettoken) {
      GetContent();
      // console.log('token avaliable');
    }
  }, [gettoken]);

  function GetContent() {
    console.log('token', gettoken);
    var myHeaders = new Headers();
    myHeaders.append('Authorization', 'Bearer ' + gettoken);

    // let url = api.get_contents;
    const params = new URLSearchParams();
    params.append('type', 'terms');
    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      // body: formdata,
      redirect: 'follow'
    };
    let url = `${api.get_contents}?${params.toString()}`;

    fetch(url, requestOptions)
      .then((response) => {
        console.log('response chekc ', response);
        if (response.status === 201 || response.status === 200) {
          return response.text();
        } else {
          return response.json().then((result) => {
            console.log('result++++++++', result);
          });
        }
      })
      .then((result) => {
        const res = JSON.parse(result);
        console.log('result ======', res);
        // const res = result?.[data];
        setValue(res.data[0]?.content);
        seteditId(res.data[0]?.id);
      })
      .catch((error) => {
        console.log('error======', error);
      })
      .finally(() => {
        setloading(false);
      });
  }

  function handler() {
    setloading(true);
    const token = localStorage.getItem('token');
    var myHeaders = new Headers();
    myHeaders.append('Authorization', 'Bearer ' + token);

    var formdata = new FormData();
    formdata.append('content', value);
    formdata.append('type', 'terms');
    formdata.append('id', editid);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(api.edit_content, requestOptions)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          setalert({ visible: false });
          return response.text();
        } else {
          return response.json().then((result) => {
            setalert({ visible: true, message: result.error });
          });
        }
      })
      .then((result) => {
        console.log('result ======', result);
      })
      .catch((error) => {
        console.log('error======', error);
      })
      .finally(() => {
        setloading(false);
      });
  }

  // When a file is selected
  // const imageHandler = useCallback(() => {
  //   // Create an input element of type 'file'
  //   const input = document.createElement('input');
  //   input.setAttribute('type', 'file');
  //   input.setAttribute('accept', 'image/*');
  //   input.click();
  //   // When a file is selected
  //   input.onchange = () => {
  //     const file = input.files[0];
  //     const reader = new FileReader();

  //     // Read the selected file as a data URL
  //     reader.onload = () => {
  //       const imageUrl = reader.result;
  //       const quillEditor = quill.current.getEditor();

  //       // Get the current selection range and insert the image at that index
  //       const range = quillEditor.getSelection(true);
  //       quillEditor.insertEmbed(range.index, 'image', imageUrl, 'user');
  //     };

  //     reader.readAsDataURL(file);
  //   };
  // }, []);
  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: [2, 3, 4, false] }],
          ['bold', 'italic', 'underline', 'blockquote'],
          [{ color: [] }],
          [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
          ['link', 'image']['clean']
        ]
        // handlers: {
        //   image: imageHandler
        // }
      },
      clipboard: {
        matchVisual: true
      }
    }),
    []
  );

  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
    'color',
    'clean'
  ];
  return (
    <Page title={`Terms & Conditions | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        <div style={{ padding: '2rem' }}>
          {/* <Grid item lg={12} sm={12} md={12}> */}
          <QuillEditor
            // style={{ height: '300px' }}
            ref={(el) => (quill.current = el)}
            defaultValue={value}
            theme="snow"
            value={value}
            formats={formats}
            modules={modules}
            onChange={(value) => setValue(value)}
          />
          {/* </Grid> */}
          <Box mt={5}>
            <LoadingButton
              disabled={false}
              loading={loading}
              sx={{
                marginTop: '5%'
              }}
              onClick={handler}
              color="primary"
              variant="contained"
            >
              Save
            </LoadingButton>
          </Box>

          <Box mt={2}>
            {alert && alert.visible && <Alert severity="error">{alert.message}</Alert>}
          </Box>
        </div>
      </Container>
    </Page>
  );
}
